// Admin — Carte du mois (deprecated form → merged with the Newsletter).
//
// Since 2026-02 the Home "Carte du mois" block is derived automatically
// from the currently-active thematic newsletter (`La Lettre des Terroirs`).
// The operator schedules a newsletter with a product, that product becomes
// the Carte du mois on the Home page — no separate editorial pipeline.
//
// This page redirects operators to the newsletter planner and also fetches
// the currently-derived carte to reassure the user that the merge is live.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ExternalLink, ArrowRight, Loader2 } from "lucide-react";

const AdminCarteDuMoisPage = () => {
  const [carte, setCarte] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/shop/carte-du-mois`)
      .then((r) => r.json())
      .then((d) => setCarte(d?.carte || null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 max-w-3xl mx-auto" data-testid="admin-carte-du-mois-merged">
      <div className="flex items-center gap-3 mb-6">
        <Star size={26} className="text-[color:var(--gv-pink)]" />
        <h1 className="text-3xl font-serif">Carte du mois</h1>
      </div>

      <div className="bg-[color:var(--gv-pink)]/10 border border-[color:var(--gv-pink)] rounded-[6px] p-5 mb-6">
        <div className="text-sm text-[color:var(--gv-ink)] leading-relaxed">
          <strong>Nouveau : la carte du mois est pilotée depuis la Newsletter.</strong>
          <p className="mt-2">
            La carte affichée sur la page d&apos;accueil est automatiquement la carte associée à
            <strong> ✉️ La Lettre des Terroirs </strong>
            active (dernière envoyée ou prochaine planifiée). Pas besoin de la définir à deux endroits.
          </p>
          <Link
            to="/admin/newsletter"
            className="inline-flex items-center gap-2 mt-3 px-4 py-2 rounded-[5px] bg-[color:var(--gv-pink)] text-white text-sm font-medium hover:opacity-90"
            data-testid="carte-goto-newsletter"
          >
            Ouvrir le planificateur Newsletter <ArrowRight size={14} />
          </Link>
        </div>
      </div>

      <div className="bg-white border border-[color:var(--gv-line)] rounded-[6px] p-5">
        <h2 className="text-lg font-medium mb-3">Carte actuellement affichée sur la Home</h2>
        {loading ? (
          <div className="flex items-center gap-2 text-[color:var(--gv-ink)]/60">
            <Loader2 size={16} className="animate-spin" /> Chargement…
          </div>
        ) : !carte ? (
          <div className="text-sm text-[color:var(--gv-ink)]/60">
            Aucune carte du mois active. Planifiez une newsletter avec une carte associée
            depuis le planificateur.
          </div>
        ) : (
          <div className="flex items-start gap-4" data-testid="current-carte">
            {carte.cover_url && (
              <img src={carte.cover_url} alt={carte.title} className="w-28 h-40 object-cover rounded" />
            )}
            <div className="flex-1">
              <div className="font-serif text-lg">{carte.title}</div>
              {carte.subtitle && <div className="text-sm text-[color:var(--gv-ink)]/70 mt-1">{carte.subtitle}</div>}
              {carte.newsletter_theme && (
                <div className="text-xs text-[color:var(--gv-pink)] mt-2">
                  Source : newsletter « {carte.newsletter_theme} »
                </div>
              )}
              <a
                href={`/shop/${carte.product_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs text-[color:var(--gv-ink)]/60 hover:text-[color:var(--gv-pink)] mt-3"
              >
                Voir la fiche produit <ExternalLink size={11} />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminCarteDuMoisPage;
